import React from "react";
import {Link} from 'react-router-dom';

export default function PageNotFound(){
  return (
    <div>
      <h1>Oops! This page does not exist. </h1>

      <nav>
         <Link to="/">Return to Gaelic Connect</Link>
      </nav>
    </div>
  );
};